function initInfiniteScroll() {
    var container = document.querySelector('[data-infinite-scroll]');
    if (!container || !container.dataset.nextUrl) return;

    var pagination = document.querySelector('.infinite-scroll-pagination');
    var loading = document.querySelector('.infinite-scroll-loading');

    if (pagination) pagination.hidden = true;

    var isFetching = false;
    var threshold = 400;

    function nearBottom() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var windowHeight = window.innerHeight;
        var docHeight = document.documentElement.scrollHeight;
        return scrollTop + windowHeight >= docHeight - threshold;
    }

    function onScroll() {
        if (!isFetching && container.dataset.nextUrl && nearBottom()) {
            loadNextPage();
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Check immediately in case the first page is short enough to already be at the bottom
    onScroll();

    function loadNextPage() {
        var nextUrl = container.dataset.nextUrl;
        if (!nextUrl) {
            window.removeEventListener('scroll', onScroll);
            return;
        }

        isFetching = true;
        if (loading) loading.hidden = false;

        fetch(nextUrl)
            .then(function(response) { return response.text(); })
            .then(function(html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newContainer = doc.querySelector('[data-infinite-scroll]');

                if (!newContainer) {
                    window.removeEventListener('scroll', onScroll);
                    return;
                }

                Array.from(newContainer.children).forEach(function(child) {
                    container.appendChild(child);
                });

                var newNextUrl = newContainer.dataset.nextUrl;
                if (newNextUrl) {
                    container.dataset.nextUrl = newNextUrl;
                } else {
                    delete container.dataset.nextUrl;
                    window.removeEventListener('scroll', onScroll);
                }
            })
            .catch(function(err) {
                console.error('Infinite scroll fetch failed:', err);
            })
            .then(function() {
                isFetching = false;
                if (loading) loading.hidden = true;
            });
    }
}

export { initInfiniteScroll };
